export default {
  statusObject: {
    SUCCESS: {
      status: '0000',
      message: 'API正常終了',
    },
    FAILURE: {
      status: '9999',
      message: 'API異常終了',
    },
    ACT_ILLEGAL: {
      status: '1000',
      message: 'actの設定内容が不正',
    },
    TODO_ILLEGAL: {
      status: '1001',
      message: 'todoの設定内容が不正',
    },
    UNAUTHORIZED: {
      status: '2000',
      message: 'くまさんAPIの実行権限なし',
    },
    NONE_CHILD_DATA: {
      status: '2100',
      message: '児童情報がありません。',
    },
    CHILD_ATTENDANCE_ID_ALAREADY_EXISTS: {
      status: '2300',
      message: '指定の児童IDはすでにシートに存在しています。',
    },
    CHILD_ATTENDANCE_NOT_CHILD_ID_DATA: {
      status: '2301',
      message: '児童一覧にこのIDの児童の情報はありません',
    },
    CHILD_ATTENDANCE_NOT_CHILD_ID: {
      status: '2302',
      message: '指定の児童IDはシートに存在していません',
    },
    CHILD_ATTENDANCE_ID_DISHONESTY: {
      status: '2303',
      message: '児童欠席シートidの設定内容が不正',
    },
    NOT_CHILD_ATTENDANCE_DATA: {
      status: '2304',
      message: '児童欠席(at_cld)シートにデータがありません',
    },
    NOT_STAFF_ATTENDANCE_DATA: {
      status: '2400',
      message: 'スタッフ欠席(at_cld)シートにデータがありません',
    },
    NOTE_NOT_FETCH_DATE: {
      status: '2600',
      message: '日付データがスプレッドシートのセルから取得できませんでした',
    },
    NOTE_DATE_DISHONESTY: {
      status: '2601',
      message: 'dateの設定内容が不正',
    },
    CHILD_BOOK_DATA_NULL: {
      status: '2603',
      message: 'cld_bookのデータはありません',
    },
    NONE_CHILD_BOOK_DATA: {
      status: '2700',
      message: '連絡帳データがありません',
    },
    PICKUP_ALAREADY_DHILD_ABSENCE: {
      status: '2701',
      message: '指定の児童はすでに欠席に設定されてます。',
    },
    PICKUP_NOT_CHILD_ID_DATA: {
      status: '2702',
      message: '児童一覧にこのIDの児童の情報はありません',
    },
    PICKUP_CHILD_DATA_DISHONESTY: {
      status: '2703',
      message: 'cldidの設定内容が不正',
    },
    TACKING_DATA_NULL: {
      status: '2800',
      message: 'tackingのデータはありません',
    },
    SEND_DATA_NULL: {
      status: '2900',
      message: 'sendのデータはありません',
    },
    NOT_ACHIEVEMENTS_DATA: {
      status: '3200',
      message: '実績記録のデータが一件もありません。',
    },
    NOT_SIGN_IMG: {
      status: '3800',
      message: '該当する児童のサインデータはありません',
    },
    NON_EXISTENT_SIGN_IMG: {
      status: '3808',
      message: 'サインデータが一件も登録されていません。',
    },
    NON_ACHIEVEMENTS: {
      status: '3400',
      message: '実績記録が1件も存在しません。',
    },
  },
  statusHandring(status: string) {
    let isStatus
    switch (status) {
      case this.statusObject.SUCCESS.status:
        isStatus = true
        break
      case this.statusObject.FAILURE.status:
        console.error(this.statusObject.FAILURE.message)
        isStatus = false
        break
      case this.statusObject.ACT_ILLEGAL.status:
        console.error(this.statusObject.ACT_ILLEGAL.message)
        isStatus = false
        break
      case this.statusObject.TODO_ILLEGAL.status:
        console.error(this.statusObject.TODO_ILLEGAL.message)
        isStatus = false
        break
      case this.statusObject.UNAUTHORIZED.status:
        console.error(this.statusObject.UNAUTHORIZED.message)
        isStatus = false
        break
      case this.statusObject.NONE_CHILD_DATA.status:
        console.error(this.statusObject.NONE_CHILD_DATA.message)
        alert('児童データがありません。')
        isStatus = false
        break
      case this.statusObject.CHILD_ATTENDANCE_ID_ALAREADY_EXISTS.status:
        console.error(
          this.statusObject.CHILD_ATTENDANCE_ID_ALAREADY_EXISTS.message
        )
        isStatus = false
        break
      case this.statusObject.CHILD_ATTENDANCE_NOT_CHILD_ID_DATA.status:
        console.error(
          this.statusObject.CHILD_ATTENDANCE_NOT_CHILD_ID_DATA.message
        )
        isStatus = false
        break
      case this.statusObject.CHILD_ATTENDANCE_NOT_CHILD_ID.status:
        console.error(this.statusObject.CHILD_ATTENDANCE_NOT_CHILD_ID.message)
        isStatus = false
        break
      case this.statusObject.CHILD_ATTENDANCE_ID_DISHONESTY.status:
        console.error(this.statusObject.CHILD_ATTENDANCE_ID_DISHONESTY.message)
        isStatus = false
        break
      case this.statusObject.NOT_CHILD_ATTENDANCE_DATA.status:
        console.error(this.statusObject.NOT_CHILD_ATTENDANCE_DATA.message)
        isStatus = false
        break
      case this.statusObject.NOT_STAFF_ATTENDANCE_DATA.status:
        console.error(this.statusObject.NOT_STAFF_ATTENDANCE_DATA.message)
        isStatus = false
        break
      case this.statusObject.NOTE_NOT_FETCH_DATE.status:
        console.error(this.statusObject.NOTE_NOT_FETCH_DATE.message)
        isStatus = false
        break
      case this.statusObject.NOTE_DATE_DISHONESTY.status:
        console.error(this.statusObject.NOTE_DATE_DISHONESTY.message)
        isStatus = false
        break
      case this.statusObject.CHILD_BOOK_DATA_NULL.status:
        console.log(this.statusObject.CHILD_BOOK_DATA_NULL.message)
        isStatus = true
        break
      case this.statusObject.NONE_CHILD_BOOK_DATA.status:
        console.error(this.statusObject.NONE_CHILD_BOOK_DATA.message)
        isStatus = true
        break
      case this.statusObject.PICKUP_ALAREADY_DHILD_ABSENCE.status:
        console.error(this.statusObject.PICKUP_ALAREADY_DHILD_ABSENCE.message)
        isStatus = false
        break
      case this.statusObject.PICKUP_NOT_CHILD_ID_DATA.status:
        console.error(this.statusObject.PICKUP_NOT_CHILD_ID_DATA.message)
        isStatus = false
        break
      case this.statusObject.PICKUP_CHILD_DATA_DISHONESTY.status:
        console.error(this.statusObject.PICKUP_CHILD_DATA_DISHONESTY.message)
        isStatus = false
        break
      case this.statusObject.TACKING_DATA_NULL.status:
        console.log(this.statusObject.TACKING_DATA_NULL.message)
        isStatus = true
        break
      case this.statusObject.SEND_DATA_NULL.status:
        console.log(this.statusObject.SEND_DATA_NULL.message)
        isStatus = true
        break
      case this.statusObject.NOT_ACHIEVEMENTS_DATA.status:
        console.log(this.statusObject.NOT_ACHIEVEMENTS_DATA.message)
        isStatus = true
        break
      case this.statusObject.NOT_SIGN_IMG.status:
        console.log(this.statusObject.NOT_SIGN_IMG.message)
        isStatus = true
        break
      case this.statusObject.NON_EXISTENT_SIGN_IMG.status:
        console.log(this.statusObject.NON_EXISTENT_SIGN_IMG.message)
        isStatus = true
        break
      case this.statusObject.NON_ACHIEVEMENTS.status:
        console.log(this.statusObject.NON_ACHIEVEMENTS.message)
        isStatus = false
        break
    }
    return isStatus
  },
}

export const existData = (text: string, arrayLength: number) => {
  if (arrayLength === 0) {
    alert(`${text}ダッシュボードに戻ります。`)
    location.href = '/dashboard'
    return
  }
}
